import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import Details from '../components/Details'

@withRouter
@inject('guidedTour') @observer
export default class GuidedTourDetails extends Component {

  static propTypes = {
    guidedTour: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    router: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.props.guidedTour.load(this.props.params.id)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.props.guidedTour.load(nextProps.params.id)
    }
  }

  render() {

    const entry = this.props.guidedTour.getById(this.props.params.id)
    if (!entry) {
      return <div>Führung nicht gefunden!</div>
    }

    return (
      <Details
        guidedTour={entry}
        params={this.props.params}
        router={this.props.router}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/guided-tour/containers/DetailsContainer.js